import { Check, Clock } from "lucide-react";

export const eur = (v) => Number(v || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";

/** Umschalter Monatlich / 6 Monate – eine Quelle (Katalog /api/pakete), keine eigenen Preise. */
export const LaufzeitSchalter = ({ k, value, onChange, dark }) => (
  <div className={`inline-flex rounded-full border p-1 text-xs ${dark ? "border-black/20 bg-ink/40" : "border-[#E5E0D4] bg-[#F9F8F4]"}`} role="tablist" data-testid="laufzeit-schalter">
    {k.laufzeiten.map((l) => {
      const gesperrt = l.code === "halbjahr" && !k.halbjahr_freigegeben;
      return (
      <button key={l.code} type="button" role="tab" aria-selected={value === l.code} aria-disabled={gesperrt} disabled={gesperrt} onClick={() => !gesperrt && onChange(l.code)} data-testid={`laufzeit-${l.code}`}
        className={`rounded-full px-4 py-1.5 font-semibold transition-colors ${gesperrt ? (dark ? "text-paper/35 cursor-not-allowed" : "text-[#B3AEA2] cursor-not-allowed") : value === l.code ? (dark ? "bg-gold text-ink" : "bg-[#111] text-white") : (dark ? "text-paper/80" : "text-[#5C574F]")}`}>
        {l.name}{gesperrt ? " · bald" : l.rabatt_prozent ? ` · −${l.rabatt_prozent} %` : ""}
      </button>
      );
    })}
  </div>
);

/** Preisblock je Paket + Laufzeit: Gesamtsumme/Vorauszahlung immer direkt sichtbar, Monatspreis beim Halbjahr nur „rechnerisch“, Netto/MwSt./Brutto eindeutig. */
export const PreisBlock = ({ p, laufzeit, k, compact }) => {
  const h = p.halbjahr;
  if (laufzeit !== "halbjahr") {
    return (
      <div data-testid={`preis-${p.code}-monat`}>
        <p className={`font-display font-semibold ${compact ? "text-xl" : "text-5xl"}`} data-testid={`paket-${p.code}-preis`}>{eur(p.preis)}<span className="text-base font-normal opacity-70"> / Monat netto</span></p>
        <p className="mt-1 text-xs opacity-70" data-testid={`paket-${p.code}-brutto`}>zzgl. {p.mwst_satz} % MwSt. = {eur(p.preis_brutto)} brutto je Monat · monatlich im Voraus, monatlich kündbar</p>
      </div>
    );
  }
  return (
    <div data-testid={`preis-${p.code}-halbjahr`}>
      <p className={`font-display font-semibold ${compact ? "text-xl" : "text-4xl"}`} data-testid={`paket-${p.code}-gesamt`}>{eur(h.gesamt_netto)}<span className="text-base font-normal opacity-70"> netto / 6 Monate</span></p>
      <p className="mt-1 text-xs font-semibold" data-testid={`paket-${p.code}-vorauszahlung`}>Einmalige Vorauszahlung für 6 Monate: {eur(h.gesamt_netto)} netto + {eur(h.mwst)} MwSt. ({p.mwst_satz} %) = <span className="underline">{eur(h.gesamt_brutto)} brutto</span></p>
      <p className="mt-1 text-xs opacity-80" data-testid={`paket-${p.code}-rechnerisch`}>Rechnerisch {eur(h.rechnerisch_monat_netto)} netto je Monat statt {eur(p.preis)} – du sparst {eur(h.ersparnis_netto)} netto ({h.rabatt_prozent} %) je Halbjahr{h.rabatt_dauerhaft ? ", dauerhaft bei jeder weiteren 6-Monats-Periode" : ""}.</p>
      {!k?.halbjahr_freigegeben && <p className="mt-1 inline-flex items-center gap-1 text-[11px] opacity-70" data-testid={`paket-${p.code}-halbjahr-vorbereitung`}><Clock size={11} /> 6-Monats-Option in Vorbereitung – noch nicht buchbar</p>}
    </div>
  );
};

export const LaufzeitHinweis = ({ k, laufzeit, className = "" }) => laufzeit === "halbjahr"
  ? <p className={`text-xs ${className}`} data-testid="laufzeit-hinweis"><Check size={12} className="inline mr-1" />{k.halbjahr_hinweis}</p>
  : <p className={`text-xs ${className}`} data-testid="laufzeit-hinweis">Alle Paketpreise {k.preis_hinweis}.</p>;
